import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import DateRangePicker from 'vanillajs-datepicker/DateRangePicker';
import Datepicker      from 'vanillajs-datepicker/Datepicker';
import pl              from 'vanillajs-datepicker/locales/pl';

Object.assign(Datepicker.locales, pl);

class ProductFilter {

	constructor(filterForm) {
		this.filterForm = filterForm;
		this.showFilterMobile();
		this.hideFilterMobile();
		this.openFilter();
		this.checkListActive();
		this.datePicker( '.filter--date' );
		this.rangeSlider( '.filter--price', 'price' );
		this.rangeSlider( '.filter--duration', 'duration' );
		this.resetForm( '.btn-reset' );
	}

	showFilterMobile() {
		let buttons = document.getElementsByClassName( 'js-mobile-filter' );
		if (buttons.length > 0) {
			Array.from( buttons ).forEach(
				button => {
					button.onclick = (event) => {
                this.filterForm.classList.add( 'is-open' );
                };
				}
			);
		}
	}

	hideFilterMobile() {
		let button = this.filterForm.querySelector( '.btn-close' );
		if ( button ) {
			button.onclick = ( event ) => {
				this.filterForm.classList.remove( 'is-open' );
			};
		}
	}

	openFilter() {
		let filters = this.filterForm.querySelectorAll( '.filter' );
		if (filters) {
			Array.from( filters ).forEach(
				(filter) => {
                filter.querySelector( '.filter__header' ).onclick = ( event ) => {
						filter.classList.toggle( 'is-open' );
                };
				}
			);
		}
	}

	checkListActive() {
		let filters = this.filterForm.querySelectorAll( '.filter--checklist' );
		if (filters) {
			Array.from( filters ).forEach(
				(filter) => {
                let checkboxes = filter.querySelectorAll( 'input[type="checkbox"]' );
					if ( checkboxes ) {
						Array.from( checkboxes ).forEach(
							(checkbox) => {
                            checkbox.onchange = ( event ) => {
									if (filter.querySelectorAll( 'input[type="checkbox"]:checked' ).length > 0) {
										  filter.classList.add( 'is-active' );
									} else {
                            filter.classList.remove( 'is-active' );
									}
								};
							}
						);
					}
				}
			);
		}
	}

	datePicker(selector) {
		const datePickerContainer = this.filterForm.querySelector( selector );

		if ( ! datePickerContainer) {
			return;
		}

		const dateFromInput           = datePickerContainer.querySelector( 'input[name="date-from"]' );
		const dateToInput             = datePickerContainer.querySelector( 'input[name="date-to"]' );
		const inputsContainer         = datePickerContainer.querySelector( '.inputs--date' );
		const weekendTrainingCheckbox = datePickerContainer.querySelector( '#weekend-training' );

    let lang = 'en';
    if ( 'pl-PL' === document.documentElement.lang ) {
      lang = 'pl';
    }

		const datePicker = new DateRangePicker(
			inputsContainer,
			{
				format: "dd.mm.yyyy",
				todayHighlight: true,
				minDate: new Date(),
				autohide: true,
				input: [dateFromInput, dateToInput],
        language: lang
			}
		);


		const handleDateChange = () => {
			const dateFrom     = dateFromInput.value;
			const dateTo       = dateToInput.value;

			if ( ! dateFrom && ! dateTo && ! weekendTrainingCheckbox.checked) {
				datePickerContainer.classList.remove( 'is-active' );
			} else {
				datePickerContainer.classList.add( 'is-active' );
			}
		};

		const handleCheckboxChange = () => {
			const dateFrom         = dateFromInput.value;
			const dateTo           = dateToInput.value;

			if (weekendTrainingCheckbox.checked || dateFrom || dateTo) {
				datePickerContainer.classList.add( 'is-active' );
			} else {
				datePickerContainer.classList.remove( 'is-active' );
			}
		};

		const setInitialValues = () => {
			const dateFrom     = dateFromInput.getAttribute( 'data-date' );
			const dateTo       = dateToInput.getAttribute( 'data-date' );

			if ( dateFrom ) {
				dateFromInput.value = dateFrom;
			}

			if ( dateTo ) {
				dateToInput.value = dateTo;
			}

			handleDateChange();
		};

		document.addEventListener( 'DOMContentLoaded', setInitialValues );
		dateFromInput.addEventListener( 'changeDate', handleDateChange );
		dateToInput.addEventListener( 'changeDate', handleDateChange );
		weekendTrainingCheckbox.addEventListener( 'change', handleCheckboxChange );
	}

	rangeSlider(selector, valueType) {
		const rangeSliderContainer = this.filterForm.querySelector( selector );
		if ( ! rangeSliderContainer) {
			return;
		}

		const slider    = rangeSliderContainer.querySelector( '.filter__body__slider' );
		const from      = parseInt( slider.dataset.from );
		const to        = parseInt( slider.dataset.to );
		const inputFrom = rangeSliderContainer.querySelector( 'input.input-from' );
		const inputTo   = rangeSliderContainer.querySelector( 'input.input-to' );
		let startValues;

		if (valueType === 'price') {
			startValues = [
			inputFrom.getAttribute( 'data-price' ) || from.toString(),
			inputTo.getAttribute( 'data-price' ) || to.toString()
			];
		} else if (valueType === 'duration') {
			startValues = [
			inputFrom.getAttribute( 'data-duration' ) || from.toString(),
			inputTo.getAttribute( 'data-duration' ) || to.toString()
			];
		} else {
			startValues = [from, to];
		}

		let sliderInstance = noUiSlider.create(
			slider,
			{
				start: startValues,
				connect: true,
				range: {
					min: from,
					max: to
				},
				step: 1
			}
		);

		function updateSliderValues() {
			const values    = sliderInstance.get();
			inputFrom.value = valueType !== 'price' ? Math.floor( values[0] ) : values[0];
			inputTo.value   = valueType !== 'price' ? Math.floor( values[1] ) : values[1];

			const currentFrom = parseInt( inputFrom.value );
			const currentTo   = parseInt( inputTo.value );
			rangeSliderContainer.classList.toggle( 'is-active', currentFrom !== from || currentTo !== to );
		}

		sliderInstance.on( 'update', updateSliderValues );

		inputFrom.addEventListener(
			'change',
			function() {
				rangeSliderContainer.classList.add( 'is-active' );
				sliderInstance.set( [inputFrom.value, null] );
				updateSliderValues();
			}
		);

		inputTo.addEventListener(
			'change',
			function() {
				rangeSliderContainer.classList.add( 'is-active' );
				sliderInstance.set( [null, inputTo.value] );
				updateSliderValues();
			}
		);

		this.filterForm.addEventListener(
			'submit',
			function(event) {
				if ( ! rangeSliderContainer.classList.contains( 'is-active' )) {
					inputFrom.removeAttribute( 'name' );
					inputTo.removeAttribute( 'name' );
				}
			}
		);

		if (valueType === 'price' && rangeSliderContainer.dataset.price) {
			inputFrom.value = rangeSliderContainer.dataset.price;
			inputTo.value   = rangeSliderContainer.dataset.price;
			rangeSliderContainer.classList.add( 'is-active' );
		}

		if (valueType === 'duration' && rangeSliderContainer.dataset.duration) {
			inputFrom.value = rangeSliderContainer.dataset.duration;
			inputTo.value   = rangeSliderContainer.dataset.duration;
			rangeSliderContainer.classList.add( 'is-active' );
		}
	}

	resetForm(button) {
		let resetButton = this.filterForm.querySelector( button );

		const updateUrlAndReload = (url) => {
			window.history.pushState( {}, '', url );
			window.location.reload();
		};

		if (resetButton) {
			resetButton.onclick              = (event) => {
				event.preventDefault();
				const url                    = window.location.href;
				const [baseUrl, queryParams] = url.split( '?' );

				if (queryParams) {
					const paramsArray = queryParams.split( '&' );

					const updatedParamsArray = paramsArray.map(
						param => {
							const [key, value]   = param.split( '=' );
							if (key === 's') {
								return `${key} = `;
							}
							return '';
						}
					).filter( Boolean );

					const cleanedUrl = `${baseUrl}${updatedParamsArray.length > 0 ? '?' : ''}${updatedParamsArray.join( '&' )}`;

					updateUrlAndReload( cleanedUrl );
				} else {
					return;
				}
			};
		}
	}

}

let productsFilter = document.getElementById( 'products-filter' );
if ( productsFilter ) {
	new ProductFilter( productsFilter );
}
